/* global ERROR_MSG */
(function app(utils) {
    const { qsa, qs, testEmail, validateRequiredFields, updateSubmitBtn, els, updateValidatedField, xuFetch, bootstrapModal } = utils;
    const { nonce } = window.siteMeta;

    const ELS = {
        ...els,
        loginForm:       qs('form[name="login_form"]'),
        loginErrorModal: qs('#errorModal'),
        loginBtn:        qs('#btn-login'),
    };

    const ERROR_MODAL = bootstrapModal(ELS.loginErrorModal);

    ELS.loginForm?.addEventListener('submit', (e) => {
        e.preventDefault();
        const email    = ELS.email.value;
        const password = ELS.password.value;

        // disable the button state
        updateSubmitBtn('Please wait...', ELS.loginBtn);

        let valid = validateRequiredFields(ELS.loginForm);

        if (!testEmail(email)) {
            valid = false;
            updateValidatedField(ELS.email, 'is-invalid', ERROR_MSG.EMAIL_INVALID);
        }

        if (!password) {
            valid = false;
            updateValidatedField(ELS.password, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
        }

        if (!valid) {
            updateSubmitBtn('__default__', ELS.loginBtn);
            return;
        }

        xuFetch(
            {
                action:   'ajaxlogin',
                _wpnonce: nonce.ajaxLogin,
                email,
                password,
                remember: true,
            },
            () => {
                window.location.href = '/?success-login';
            },
            (error) => {
                const { data: msg } = error;
                const errorMsg = qs('.errorMessage', ELS.loginErrorModal);
                updateSubmitBtn('__default__', ELS.loginBtn);
                qsa('.is-valid').forEach(el => el.classList.remove('is-valid'));
                if (errorMsg) errorMsg.innerHTML = msg || 'Something went wrong. Please try again.';
                ERROR_MODAL.show();
            },
        );
    });
}(window.utilities));
